import React from 'react';
import ReactDOM from 'react-dom';
// css files imports
import './index.css';
import './assets/css/custom.css'
import './assets/css/style.css'
import './assets/css/style2.css'
import './assets/css/global.css'
// js files import
import './assets/js/custom'

import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import AlertOptions from './constants/AlertOptions';

ReactDOM.render(
  <React.StrictMode>
    <AlertProvider template={AlertTemplate} {...AlertOptions}>
      <App />
    </AlertProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
